import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Users, MapPin, Coffee } from "lucide-react";

const tickerMessages = [
  {
    id: 1,
    text: "12 looped in to the Hackney Sunday walk",
    icon: Users,
    color: "text-salmon",
  },
  {
    id: 2,
    text: "New loop posted in Battersea: volleyball at 6:30pm",
    icon: MapPin,
    color: "text-salmon",
  },
  {
    id: 3,
    text: "Coffee at Monmouth: 4 looped in, starts in 20 min",
    icon: Coffee,
    color: "text-salmon",
  },
];

export default function SocialProofTicker() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  // Only activate after scrolling past the hero section
  useEffect(() => {
    const handleScroll = () => {
      setPastHero(window.scrollY > window.innerHeight);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!pastHero) {
      setIsVisible(false);
      return;
    }

    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    const interval = setInterval(() => {
      setIsVisible(false);

      const hideTimeout = setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % tickerMessages.length);
      }, 600);

      const showTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 700);

      return () => {
        clearTimeout(hideTimeout);
        clearTimeout(showTimeout);
      };
    }, 7000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [pastHero]);

  const currentMessage = tickerMessages[currentIndex];
  const Icon = currentMessage.icon;

  return (
    <div className="fixed bottom-6 left-4 right-4 md:right-auto md:left-8 z-40 pointer-events-none flex justify-center md:justify-start">
      <AnimatePresence>
        {isVisible && (
          <motion.div
            key={currentMessage.id}
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            className="bg-canvas/90 backdrop-blur-md shadow-xl rounded-full py-3 px-5 flex items-center gap-3"
          >
            <Icon className={currentMessage.color} size={18} />
            <span className="text-sm font-medium text-ink">
              {currentMessage.text}
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
